import { Component, ErrorInfo, ReactNode } from 'react';
import { TFunction } from 'i18next';
import { withTranslation } from 'react-i18next';

import { logError } from 'entities';

import { Button } from 'components/Blocks';
import { WarningIcon } from '../Icons';

interface ErrorProps {
  t: TFunction;
  children: ReactNode;
}

interface ErrorState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorProps, ErrorState> {
  constructor(props: ErrorProps) {
    super(props);
    this.state = { hasError: false };
  }

  public static getDerivedStateFromError(_error?: Error): ErrorState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, reactInfo: ErrorInfo) {
    logError({ error, reactInfo });
  }

  reload() {
    window.location.reload();
  }

  render(): ReactNode {
    const { t, children } = this.props;
    const { hasError } = this.state;

    if (!hasError) return children;

    return (
      <div className="flex h-screen items-center justify-center px-5">
        <div className="flex flex-col items-center justify-center gap-4">
          <WarningIcon size={70} color="primary" />

          <h2 className="text-center text-[34px] leading-10">{t('an-error-happened')}</h2>

          <p>{t('we-are-looking-into-it')}</p>

          <Button onClick={this.reload}>{t('refresh')}</Button>
        </div>
      </div>
    );
  }
}

export default withTranslation()(ErrorBoundary);
